module.exports = __webpack_public_path__ + "img/gen3_zh.9d774595.png";